import { render, staticRenderFns } from "./membership_coupon.vue?vue&type=template&id=4990b3d0&scoped=true"
import script from "./membership_coupon.vue?vue&type=script&lang=js"
export * from "./membership_coupon.vue?vue&type=script&lang=js"
import style0 from "./membership_coupon.vue?vue&type=style&index=0&id=4990b3d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4990b3d0",
  null
  
)

export default component.exports